<script setup>

import {useRoute, useRouter} from "vue-router";
import {storeToRefs} from "pinia/dist/pinia";
import {useUserAdvocateStore} from "@/stores/userAdvocate.store";
import {onMounted, ref} from "vue";
import {showToast} from "vant";


const route = useRoute();
const router = useRouter();
const userAdvocateStore = useUserAdvocateStore();
const {userAdvocate} = storeToRefs(userAdvocateStore);
const show = ref(false);

onMounted(async () => {
    console.log(userAdvocate.value.reports_share);
    if (route.params.id > 0) {
        await userAdvocateStore.fetchOne(route.params.id);
    }
});

const doSubmit = () => {
    show.value = true;
};

const onSign = async (data) => {
    show.value = false;
    userAdvocate.value.signature_file = String(data.image);
    if (route.params.id === '0') {
        await userAdvocateStore.createOne().then(() => {
            router.push('/advocate/' + userAdvocate.value.id);
        });
    } else {
        await userAdvocateStore.updateOne(route.params.id);
    }
};

const onClear = () => {
    show.value = false;
    userAdvocate.value.signature_file = '';
    showToast('Your signature is cleared');
}

</script>

<template>
    <van-form @submit="doSubmit">
        <van-cell-group inset>
            <van-field
                v-model="userAdvocate.first_name"
                label="First Name"
                placeholder="First Name"
                size="large"
                required
                :rules="[{ required: true, message: 'Please input first name' }]"
            />
            <van-field
                v-model="userAdvocate.last_name"
                label="Last Name"
                placeholder="Last Name"
                size="large"
                required
                :rules="[{ required: true, message: 'Please input last name' }]"
            />
            <van-field
                v-model="userAdvocate.email"
                label="Email"
                placeholder="Email"
                size="large"
                required
                :rules="[{ required: true, message: 'Please input Email' }]"
            />
            <van-field
                v-model="userAdvocate.relation"
                label="Relation"
                placeholder="Relation"
                size="large"
                required
                :rules="[{ required: true, message: 'Please input Relation' }]"
            />
        </van-cell-group>

        <van-divider/>

        <van-cell-group inset>
            <van-cell>
                <template #title>
                    <b>Status</b>
                </template>
            </van-cell>
            <van-radio-group v-model="userAdvocate.status">
                <van-cell-group>
                    <van-cell title="Approved" clickable @click="userAdvocate.status = 'approved'">
                        <template #right-icon>
                            <van-radio name="approved"/>
                        </template>
                    </van-cell>
                </van-cell-group>
                <van-cell-group>
                    <van-cell title="Disabled" clickable @click="userAdvocate.status = 'disabled'">
                        <template #right-icon>
                            <van-radio name="disabled"/>
                        </template>
                    </van-cell>
                </van-cell-group>
            </van-radio-group>
        </van-cell-group>

        <van-divider/>

        <van-cell-group inset>
            <van-cell>
                <template #title>
                    <b>Reports Share</b>
                </template>
            </van-cell>
            <van-cell-group>
                <van-cell v-for="(enabled, report) in userAdvocate.reports_share" :title="report" :key="enabled" clickable>
                    <template #right-icon>
                        <van-switch v-model="userAdvocate.reports_share[report]" />
                    </template>
                </van-cell>
            </van-cell-group>
        </van-cell-group>

        <van-divider/>

        <van-image v-if="userAdvocate.signature_file" :src="userAdvocate.signature_file"/>

        <van-dialog v-model:show="show" title="Sign your request" :show-confirm-button="false" :show-cancel-button="false" >
            <van-signature @submit="onSign" @clear="onClear" confirm-button-text="Signature" clear-button-text="Clear"/>
        </van-dialog>

        <van-divider/>

        <van-cell-group inset>
            <van-button v-if="route.params.id === '0'" block round type="success" native-type="submit">
                Create
            </van-button>
            <van-button v-else block round type="success" native-type="submit">
                Update
            </van-button>
        </van-cell-group>


    </van-form>
</template>
